<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="m17.27 6.73-4.24 10.13-1.64-4.25-.82-.32-3.43-1.33zm3.73-3.73-18 7.53v.98l6.84 2.65 2.64 6.84h.98z"
    />
  </svg>
</template>
